export default {
    library_categories: "Categories",
    library_file_not_found: "Library file not found",
    loading_files: "Loading files",
    no_files_are_available_at_the_moment: "No files are currently available",
    no_files_are_available_with_the_selected_filter: "There are no files available for the selected filter"
}